import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function ProtectedRoute({ menuKey, children }) {
  const { hasMenuAccess, loading } = useAuth();

  if (loading) return null;

  if (!hasMenuAccess(menuKey)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
